export default __webpack_public_path__ + "static/media/drendering.b2107e60.webp";